import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectItemImportApi = {
    getProjectItemImportById: (id: number, trialId: number): Observable<Dtos.GetProjectItemImportByIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectItemImportById = new Dtos.GetProjectItemImportById();

        request.id = id;
        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetProjectItemImportByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProjectItemImport: (projectItemImport: Dtos.ProjectItemImport): Observable<Dtos.SetProjectItemImportResponse> => {
        //Create the request.
        let request: Dtos.SetProjectItemImport = new Dtos.SetProjectItemImport();

        request.id = projectItemImport.id;
        request.projectId = projectItemImport.projectId;
        request.projectItemImport = projectItemImport;

        // send request
        const response: Promise<Dtos.SetProjectItemImportResponse> = client.post(request);

        return Observable.from(response);
    }
}